// extracted by mini-css-extract-plugin
export var bigAvatarShadow = "quote-block-module--bigAvatarShadow--AnB3Z";
export var shadowInnovate = "quote-block-module--shadowInnovate--ORVnz";
export var shadowDesign = "quote-block-module--shadowDesign--PbeTk";
export var shadowDevelop = "quote-block-module--shadowDevelop--m6EJk";
export var shadowDeploy = "quote-block-module--shadowDeploy--+Q4pr";